export const capitalizeFirstLetter = (val: string): string =>
  String(val).charAt(0).toUpperCase() + String(val).slice(1);

export const basicStringParse = (value: string): string =>
  capitalizeFirstLetter(value.replaceAll("_", " "));

const numberWithCommas = (x: number | string): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

type LayerDetails = {
  /**
   * Note that leaving this blank will result in the `featureKey` being parsed
   * with `basicStringParse` (see FeatureLayer.tsx)
   *
   * If `key` has a value, it will be used as-is
   */
  key?: string;
  /**
   * Note that leaving this blank will result in the `featureValue` being
   * parsed with `basicStringParse` (see FeatureLayer.tsx)
   *
   * If `parser` has a value, it will be used to parse the `featureValue` into
   * a more user-friendly string
   */
  parser?: (value: string) => string;
};

/**
 * A **very** basic placeholder to parse the keys into "better" labels
 *
 * This should be replaced by `i18n` keys/values in the future
 *
 * @note Keys that exist here will render to the UI. Comment them out to hide
 * them.
 *
 */
export const LAYER_DETAILS: Record<string, LayerDetails> = {
  // Shared details - START
  name: {},
  // source: { key: "Source" },
  // Shared details - END
  // Transport details - START
  bicycle: { key: "Bicycle allowed" },
  designation: {
    // key: "Designation",
  },
  horse: { key: "Horses allowed" },
  sac_scale: {
    key: "Hikability",
  },
  button_operated: {},
  crossing: { key: "Crossing type" },
  // NOTE: This may need a more generic "key" value
  highway: {
    key: "Road type",
  },
  "traffic_signals:sound": { key: "Traffic signals have sound" },
  "traffic_signals:vibration": { key: "Traffic signals have vibration" },
  maxspeed: { key: "Maximum speed" },
  lane_markings: {},
  lit: {},
  // "mvdgis:cod_nombre": {},
  oneway: { key: "One-way" },
  sidewalk: { key: "Pavements" },
  "sidewalk:both:surface": { key: "Pavement surface" },
  // "source:maxspeed": {},
  surface: { key: "Surface type" },
  // TODO: understand what this value means
  // width: {},
  "sidewalk:left:surface": { key: "Left-hand pavement surface" },
  lanes: { key: "Number of lanes" },
  // old_name: { key: "Previous name" },
  short_name: {},
  // "source:oneway": {},
  smoothness: { key: "Road quality" },
  // junction: { key: "Junction type" },
  "lanes:bus": { key: "Number of bus lanes" },
  shoulder: {},
  "sidewalk:right:surface": { key: "Right-hand pavement surface" },
  // "source:surface": {},
  // "maxspeed:type": {},
  noname: { key: "Unnamed" },
  foot: { key: "Footpath" },
  service: {},
  access: { key: "Access type" },
  // "source:name": {},
  // Transport details - END
  // Land details - START
  landuse: { key: "Purpose" },
  // "mvdgis:cod_nom_es": {},
  // "mvdgis:nom_tipo_e": {},
  // "mvdgis:nro_espaci": {},
  // "mvdgis:source": {},
  // TODO: understand what this value means
  // natural: {},
  // "ref:GB:uprn": {},
  // description: {},
  residential: { key: "Area type" },
  // Land details - END
  // Sports details - START
  // ...
  // Sports details - END
  // Power details - START
  power: { key: "Power type" },
  cables: { key: "Number of cables" },
  operator: {},
  // "operator:wikidata": {},
  voltage: { parser: (v) => `${numberWithCommas(v)} V` },
  // wires: { key: "Wire type" },
  // Power details - END
  // Aeroways details - START
  // ...
  // Aeroways details - END
  // Infrastructure details - START
  amenity: {},
  barrier: {},
  building: {
    key: "Building type",
    parser: (v) =>
      v.toLowerCase() === "yes" ? "Unspecified" : capitalizeFirstLetter(v),
  },
  fence_type: {},
  // In Infastructure, this appeared to be the post code for a "post_box" `amenity`
  // "ref": {},
  // This appears to be some kind of unique land identifier
  // "ref:GB:uprn": {},

  // Infrastructure details - END
};
